module.exports = "<a target=\"_blank\" ng-href=\"{{$ctrl.mapLinkUrl}}\" class=\"google-map\" style=\"background-image:url(&quot;{{$ctrl.mapImageUrl}}&quot;)\"></a> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/googleMap/googleMap.html
// module id = 846
// module chunks = 0